import React from 'react';
import _ from 'lodash';
import { Helmet } from 'react-helmet';
import { Page } from '@janus.team/janus-particles';
import copilot from '@janus.team/janus-copilot/cjs/janus-copilot';
import { UndergoingVerification } from './UndergoingVerification';
import { UnsupportedCurrency } from './UnsupportedCurrency';

/**
 * Verify Tenant is Active and is billed in a supported currency
*/

export const TenantVerifier = ({ customer: customerFromProps, children }) => {
  const allowedCurrency = ['USD', 'AUD', 'EUR', 'GBP', 'CAD', 'SAR', 'MXN'];
  const customerFromSession = _.get(React.useContext(copilot.context.session), ['session', 'session', 'customer']);
  const customer = customerFromProps || customerFromSession;
  const { isReady, currency } = customer || {};
  const requiredConditions = [
    {
      title: 'Undergoing Account Verification',
      condition: isReady,
      component: (<UndergoingVerification />),
    },
    {
      title: 'Currency Requirements',
      condition: allowedCurrency.includes(currency),
      component: (<UnsupportedCurrency currency={currency} />),
    },
  ];
  const newArray = requiredConditions.filter(((a) => a.condition === false));
  const invalidCondition = _.first(newArray);

  if (!invalidCondition) {
    return children;
  }

  return (
    <Page>
      <Helmet>
        <title>Verification Error</title>
      </Helmet>
      <Page.Main>
        <Page.MainHeader title="Managed GCP" />
        <Page.MainBody>
          <Page.MainBodySection title={invalidCondition.title}>
            {invalidCondition.component}
          </Page.MainBodySection>
        </Page.MainBody>
      </Page.Main>
    </Page>
  );
};
